
import {LOGIN_SUCCESS,LOGIN_FAILER,LOGIN_CART} from "./actionType"
const initialState = {
    isAuth : false,
    username : "",
    cart: 0
}

export const authReducer = (state = initialState,action) =>{
    switch (action.type){
        case LOGIN_SUCCESS :
            return {...state,isAuth: true, username: action.payload}
      case LOGIN_FAILER :
            return {...state,isAuth:false }
    
      case LOGIN_CART :
            return {...state, cart : action.payload}
      default:
                return state
    }
    
}

